import React, { useContext, useEffect, useState } from 'react';
import { Menu } from 'antd';
import { useLocation, NavLink } from 'react-router-dom';
import {
  AlertFilled,
  CalendarFilled,
  CompassFilled,
  ExclamationCircleFilled,
  FileTextFilled,
  HomeFilled,
  QuestionCircleFilled,
  ScheduleFilled,
  SettingFilled,
} from '@ant-design/icons';
import { UserContext } from '../contexts';
import { hasAdminPageRole, hasSmatPlansPageRole, hasReportsPageRole } from '../../utils';

export function Navigation() {
  const { pathname } = useLocation();
  const [path, setPath] = useState('');
  const { user } = useContext(UserContext);

  useEffect(() => {
    const path = '/' + pathname.split('/')[1];
    setPath(path);
  }, [pathname]);

  return (
    <>
      <Menu theme="dark" mode="horizontal" selectedKeys={[path]} style={{ backgroundColor: '#294D78', textAlign: 'right' }}>
        <Menu.Item icon={<HomeFilled />} key="/">
          <NavLink to="/">Ana sayfa</NavLink>
        </Menu.Item>
        {user && (
          <Menu.Item icon={<ExclamationCircleFilled />} key="/risks">
            <NavLink to="/risks">Riskler</NavLink>
          </Menu.Item>
        )}
        {user && (
          <Menu.Item icon={<ScheduleFilled />} key="/smats">
            <NavLink to="/smats">SMAT'lar</NavLink>
          </Menu.Item>
        )}
        {user && (
          <Menu.Item icon={<AlertFilled />} key="/ewos">
            <NavLink to="/ewos">EWO'lar</NavLink>
          </Menu.Item>
        )}
        {user && user.areas && user.areas.length > 0 && (
          <Menu.Item icon={<CompassFilled />} key="/actions">
            <NavLink to="/actions">Aksiyonlar</NavLink>
          </Menu.Item>
        )}
        {hasSmatPlansPageRole(user) && (
          <Menu.Item icon={<CalendarFilled />} key="/smat-plans">
            <NavLink to="/smat-plans">Planlama</NavLink>
          </Menu.Item>
        )}
        {hasReportsPageRole(user) && (
          <Menu.Item icon={<FileTextFilled />} key="/reports">
            <NavLink to="/reports">Raporlar</NavLink>
          </Menu.Item>
        )}
        {hasAdminPageRole(user) && (
          <Menu.Item icon={<SettingFilled />} key="/admin">
            <NavLink to="/admin">Yönetim</NavLink>
          </Menu.Item>
        )}
        {!user && (
          <Menu.Item icon={<QuestionCircleFilled />} key="/help">
            <NavLink to="/help">Yardım</NavLink>
          </Menu.Item>
        )}
      </Menu>
    </>
  );
}
